import { Component, Input } from '@angular/core';

import { L10nService, PageLayout } from '@jct/localization';

@Component({
  selector: 'auth-layout',
  templateUrl: './auth-layout.component.html',
})
export class AuthLayoutComponent {
  constructor(
    public l10n: L10nService,
    public pageLayout: PageLayout,
  ) {}

  @Input()
  showLoginAction = false;

  @Input()
  showCalculatorAction = true;

  readonly year = new Date().getFullYear();
}
